import styled from 'styled-components';
export const ChipInput = /*#__PURE__*/styled.input.withConfig({
  displayName: "ChipInput",
  componentId: "sc-1sp4qrs-0"
})(["appearance:none;opacity:0;position:absolute;z-index:0;width:1px;height:1px;"]);